import { useNavigate } from "react-router-dom";
import { ArrowLeft, LogIn } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Login() {
  const navigate = useNavigate();

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-ink-900 text-white flex flex-col" data-testid="login-page">
      <div className="noise-overlay" aria-hidden />
      <div className="p-5 md:p-10">
        <button
          data-testid="login-back"
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-white/60 hover:text-white transition-colors"
        >
          <ArrowLeft size={16} /> Back to site
        </button>
      </div>

      <div className="flex-1 grid place-items-center px-5">
        <div className="w-full max-w-md border border-line bg-ink-800 p-8 md:p-12">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-acid mb-4">Admin access</p>
          <h1 className="font-display font-black tracking-tighter text-4xl md:text-5xl leading-[0.9]">
            LEADS<br />INBOX
          </h1>
          <p className="mt-5 text-white/55 leading-relaxed">
            Sign in to view and manage quote requests for {SITE.brandFull}. Access is restricted to authorized accounts.
          </p>

          <button
            data-testid="google-signin"
            onClick={signIn}
            className="group mt-8 w-full flex items-center justify-between bg-acid text-ink-900 px-6 py-5 font-display font-black tracking-tight text-xl hover:bg-acid-hover transition-colors"
          >
            Sign in with Google
            <LogIn size={22} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </div>
  );
}
